import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Logo from "@/components/Logo";
import { useCustomerAuth } from "@/contexts/CustomerAuthContext";
import { safeGet, safeSet } from "@/lib/storage";

const EXIT_DURATION = 620;

export default function WelcomeGate() {
  const { pathname } = useLocation();
  const { customer } = useCustomerAuth();
  const [visible, setVisible] = useState(() => {
    const storage = typeof window !== "undefined" ? window.sessionStorage : null;
    return pathname === "/" && safeGet(storage, "tw_welcome_continued") !== "1";
  });
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const locked = visible && pathname === "/";
    if (typeof document !== "undefined") document.body.classList.toggle("welcome-open", locked);
    return () => { if (typeof document !== "undefined") document.body.classList.remove("welcome-open"); };
  }, [visible, pathname]);

  useEffect(() => {
    if (customer) setVisible(false);
  }, [customer]);

  if (!visible || pathname !== "/") return null;

  const continueToHome = () => {
    setClosing(true);
    safeSet(typeof window !== "undefined" ? window.sessionStorage : null, "tw_welcome_continued", "1");
    window.setTimeout(() => setVisible(false), EXIT_DURATION);
  };

  return (
    <div className={`welcome-gate${closing ? " welcome-gate--closing" : ""}`} role="dialog" aria-modal="true" aria-labelledby="welcome-title">
      <div className="welcome-gate__ambient" aria-hidden="true">
        <span className="welcome-gate__orb welcome-gate__orb--orange" />
        <span className="welcome-gate__orb welcome-gate__orb--blue" />
        <span className="welcome-gate__grid" />
      </div>

      <main className="welcome-gate__content">
        <div className="welcome-gate__logo-wrap"><Logo size="xl" /></div>
        <h1 id="welcome-title" className="welcome-gate__title">
          Un seul point d’entrée.<br />
          <span>Une expérience simple.</span>
        </h1>
        <p className="welcome-gate__description">Explorez Team Work librement, choisissez votre univers et connectez-vous seulement lorsque vous en avez besoin.</p>
        <button type="button" className="welcome-gate__button" onClick={continueToHome}>Explorer Team Work</button>
      </main>
    </div>
  );
}
